import React from "react";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import ReviewsCard from "../Common/ReviewsCard";
import Paginate from "../../layout/Paginate";

const ReviewsReceieved = ({ title, products }) => {
  return (
    <div className="grow">
      <FilterHeader title={title} />

      <Paginate
        itemsPerPage={5}
        data={products}
        element={(props) => <ReviewsCard {...props} />}
        containerClassName="flex flex-col gap-4 mt-8"
      />
    </div>
  );
};

export default ReviewsReceieved;
